<template>
</template>

<script>

import Nav from "../../components/Nav.vue";
import Footer from "../../components/Footer.vue";

export default {
  name: 'TosolaApp',
  components: {Nav, Footer},
  data() {
    return {
      redirect: {
        ios: {
          path: 'https://apps.apple.com/app/id1630877428',
          status: true
        },
        android: {
          path: 'https://play.app.goo.gl/?link=https://play.google.com/store/apps/details?id=com.redbluestories.TheBearChapters',
          status: true
        }
      }
    }
  },
  methods: {
    isAppleDevice() {
      return [
        'iPad Simulator',
        'iPhone Simulator',
        'iPod Simulator',
        'iPad',
        'iPhone',
        'iPod'
      ].includes(navigator.userAgent)
      // iPad on iOS 13 detection
      || (navigator.userAgent.includes("Mac"))
    }
  },
  mounted() {
      if (/Android/i.test(navigator.userAgent)) {
        if (this.redirect.android.status) {
          window.location.href = this.redirect.android.path;
        }
      } else if (/iPhone|iPod|iPad|Mac/i.test(navigator.userAgent)) {
        if (this.redirect.ios.status) {
          window.location.href = this.redirect.ios.path;
        }
      }
  }
}
</script>

<style lang="scss" scoped>

#app {
  padding-top: 6em;
  padding-bottom: 6em;

  h3 {
      margin: 1em 0 1em 0;
  }

  .app-section {
     margin-bottom: 1em;
  }

  img {
    max-width: 8em;
    border-radius: 20px;
  }
}

</style>